import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PenguinIllustration } from "@/components/PenguinState";

function Maintenance({ status, msg }) {
  const disabled = status === "DISABLED"; // DISABLED → Service Unavailable, MAINTENANCE → Under Maintenance
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center" data-testid="feature-maintenance">
      {disabled ? (
        <PenguinIllustration variant="service-unavailable" size="page" />
      ) : (
        // Under Maintenance artwork always renders here (functional screen — not tied to the cosmetic penguin toggle)
        <img
          src="/brand/penguin-maintenance-2.png"
          alt="ZRo Pe penguin working — we'll be back soon"
          loading="eager"
          decoding="async"
          data-testid="maintenance-penguin-image"
          className="mx-auto h-auto w-[clamp(200px,60vw,440px)] max-h-[46vh] object-contain"
        />
      )}
      <h2 className="font-display mt-5 text-xl font-bold text-[#0B132B] sm:text-2xl">{disabled ? "Service Unavailable" : "Under Maintenance"}</h2>
      <p className="mt-2 max-w-md text-sm text-slate-500">{msg || (disabled ? "This service is currently not available. Please try later." : "We're working to make things better for you. Please check back soon.")}</p>
      <Link to="/dashboard" className="mt-6 rounded-full bg-[#14B8A6] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#0B132B]">Back to dashboard</Link>
    </div>
  );
}

// Server-authoritative feature gate. `module` (new) or legacy `flag` both resolve to a key.
export default function FeatureGate({ flag, module, children }) {
  const key = module || flag;
  const [st, setSt] = useState("loading");
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.get("/features").then((r) => {
      const m = r.data?.modules?.[key];
      if (m) { setSt(m.status); setMsg(m.message); }
      else setSt("LIVE"); // unknown key → fail-safe open
    }).catch(() => setSt("LIVE")); // config unavailable → safe default: do not block
  }, [key]);
  if (st === "loading") return null;
  if (st === "LIVE") return children;
  if (st === "DISABLED") return <Navigate to="/dashboard" replace />; // hide/block entirely
  return <Maintenance status={st} msg={msg} />; // MAINTENANCE → page stays, shows maintenance state
}
